import { render, staticRenderFns } from "./PpiKepatuhanTrenCard.vue?vue&type=template&id=f35c1422&scoped=true&"
import script from "./PpiKepatuhanTrenCard.vue?vue&type=script&lang=ts&"
export * from "./PpiKepatuhanTrenCard.vue?vue&type=script&lang=ts&"
import style0 from "./PpiKepatuhanTrenCard.vue?vue&type=style&index=0&id=f35c1422&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f35c1422",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VAlert,VCard,VCardText,VCardTitle,VCol,VProgressLinear,VRow,VSelect})
